import type { FunnelPageItem, FunnelRoutingEvent } from '../types';
import { DRAFT_FUNNEL_PAGE_ID, MAX_BRANCH_DEPTH, MAX_FUNNEL_PAGES } from '../constants/funnels.constants';

export function getFunnelBranchDepths(pages: FunnelPageItem[]): Map<number, number> {
    const saved = pages.filter(p => p.page_id !== DRAFT_FUNNEL_PAGE_ID);
    const parentByChild = new Map<number, number>();
    saved.forEach(source => {
        if (!source.routing) return;
        (['on_purchase', 'on_skip'] as FunnelRoutingEvent[]).forEach(event => {
            const target = source.routing?.[event];
            if (!target) return;
            if (target.page_id === source.page_id) return;
            if (parentByChild.has(target.page_id)) return;
            parentByChild.set(target.page_id, source.page_id);
        });
    });

    const depths = new Map<number, number>();
    const resolve = (pageId: number, seen: Set<number>): number => {
        if (depths.has(pageId)) return depths.get(pageId) ?? 0;
        if (seen.has(pageId)) return 0;
        seen.add(pageId);
        const parent = parentByChild.get(pageId);
        if (parent === undefined) {
            depths.set(pageId, 0);
            return 0;
        }
        const d = resolve(parent, seen) + 1;
        depths.set(pageId, d);
        return d;
    };
    saved.forEach(p => resolve(p.page_id, new Set()));
    return depths;
}

export function getFunnelPageDepth(pages: FunnelPageItem[], pageId: number): number {
    return getFunnelBranchDepths(pages).get(pageId) ?? 0;
}

export function isAtMaxFunnelPages(pages: FunnelPageItem[]): boolean {
    const savedCount = pages.filter(p => p.page_id !== DRAFT_FUNNEL_PAGE_ID).length;
    return savedCount >= MAX_FUNNEL_PAGES;
}

export function isAtMaxBranchDepthFrom(pages: FunnelPageItem[], sourcePageId: number): boolean {
    return getFunnelPageDepth(pages, sourcePageId) >= MAX_BRANCH_DEPTH - 1;
}
